






















import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "../../../../base/components/developer/mixins";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../../../base/components/system/mixins";
import { PdfViewer } from "../../../../base/components/system/viewers";
import { Separator } from "../../../../base/components/system";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { FormatListViewerDebugTool } from "../../developer";
import { FormatArchiveSelector, FormatTwoPaneSelector } from "../selectors";

@Component({
  components: {
    FormatTwoPaneSelector,
    FormatArchiveSelector,
    PdfViewer,
    Separator,
    FormatListViewerDebugTool,
  }
})
export default class FormatListViewer extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin, DeveloperPresentableMixin) {
  @Prop()
  selectedArchive: EditableFormatSummary;

  @Prop({ default: true })
  shouldShowArchiveSelector: boolean;

  data() {
    return {
      selectionOfAllFormats: null as EditableFormatSummary[],
    };
  }
  selectionOfAllFormats: EditableFormatSummary[];
  selectorWidth: number = 1200;
  isEditingFormat: boolean = false;

  get editingSource(): EditableFormatSummary {
    return this.value;
  }

  set editingSource(value: EditableFormatSummary) {
    this.input(value);
  }

  get isFormatSelected(): boolean {
    return (this.editingSource !== null);
  }

  get selectedFormatId(): number {
    return this.isFormatSelected
      ? this.editingSource.id
      : null;
  }

  get selectedPreviewSource(): string {
    return (!this.selectedArchive || !this.selectedArchive.previewSource)
      ? ""
      : this.selectedArchive.previewSource.source;
  }

  editingFormat(value: boolean): void {
    // フォーマット選択ダイアログ表示中に編集を行われた場合、DialogMixinで回避出来ずPDFが表示されてしまうため暫定対応
    this.isEditingFormat = value;
  }

  handleFolderSelectionChanged(formats: EditableFormatSummary[]): void {
    this.selectionOfAllFormats = formats;
  }

  @Emit("update:selectedArchive")
  updateSelectedArchive(value: EditableFormatSummary): void {}

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("selectedListTabChanged")
  selectedListTabChanged(name: string): void {}
}
